<template>
  <v-container fluid class="background py-8 py-md-16" id="platform">
    <v-container>
      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline secondary--text font-weight-bold"
            data-aos="fade-down"
          >
            PLATAFORMA
          </span>
          <h2
            class="display-1 greydark--text font-weight-bold mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Lo que impulsa cada vertical
          </h2>
          <p
            class="text-h6 greylight--text mt-4 mx-auto"
            style="max-width: 700px;"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Tres capacidades centrales disponibles en todas
            las verticales Pertinax
          </p>
        </v-col>
      </v-row>

      <v-row class="align-stretch">
        <v-col
          v-for="(cap, index) in capabilities"
          :key="cap.title"
          cols="12"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="300 + (index * 100)"
        >
          <v-card class="pa-6 text-center h-100" elevation="3">
            <v-avatar :color="cap.color" size="72" class="mb-4">
              <v-icon size="40" color="white">{{ cap.icon }}</v-icon>
            </v-avatar>
            <h3 class="text-h5 greydark--text font-weight-bold mb-3">
              {{ cap.title }}
            </h3>
            <p class="text-body-1 greylight--text">
              {{ cap.description }}
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'PlatformSection',
  data() {
    return {
      capabilities: [
        {
          title: 'Procesos Digitales',
          description: 'Flujos de trabajo configurables sin código. Automatizá aprobaciones, notificaciones y tareas repetitivas específicas de tu industria.',
          icon: 'mdi-cog-transfer',
          color: 'accent',
        },
        {
          title: 'Documentos con AI',
          description: 'Validación automática de documentos críticos. La IA detecta errores, inconsistencias y campos faltantes antes de que sean un problema.',
          icon: 'mdi-file-document-check',
          color: 'secondary',
        },
        {
          title: 'Control de Gastos',
          description: 'Trazabilidad completa de costos por operación. Aprobaciones con reglas, alertas automáticas y reportes sin Excel.',
          icon: 'mdi-chart-line',
          color: 'success',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

</style>
